import React, { Component } from "react";

// React-table library requires to import css as well:
import ReactTable from "react-table";
import "react-table/react-table.css"; // eslint-disable-next-line

import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Typography from "@material-ui/core/Typography";
import HighlightOff from "@material-ui/icons/HighlightOff";

import { mesi, orariControlli } from "../../../../utils/constants.js";
import { Button } from "@material-ui/core";

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: "190px",
      // maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 270,
    },
  },
};

const styles = {
  gridcontainer_column: {
    padding: "0px 4px",
  },
  formcontrol: {
    marginBottom: "30px",
    width: "270px",
    padding: "0px 4px",
  },
  container: {
    //maxWidth: "800px",
    padding: "0px 0px 20px 0px",
  },
  tablecontainer: {
    margin: "10px 0px 10px 0px",
    paddingBottom: "10px",
  },
};

export default class FormAnnuale extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cadenze: [],
      visible: false,
      cadenza: {
        orario: "08:00:00",
        giornoSettimana: null,
        mese: "JANUARY",
        giornoMese: 1,
        schedaId: null,
        id: null,
        controlloConformitaId: null,
      },
    };
  }

  onSelect = (event) => {
    this.handleChange(event.target.name, event.target.value);
  };

  handleChange = (name, value) => {
    let cadenza = JSON.parse(JSON.stringify(this.state.cadenza));
    cadenza[name] = value;

    this.setState({
      cadenza,
    });
  };

  getGiorniMese = (mese) => {
    switch (mese) {
      case "FEBRUARY":
        return Array.from({ length: 28 }, (_, i) => i + 1);
      case "APRIL":
      case "JUNE":
      case "SEPTEMBER":
      case "NOVEMBER":
        return Array.from({ length: 30 }, (_, i) => i + 1);
      default:
        return Array.from({ length: 31 }, (_, i) => i + 1);
    }
  };

  render() {
    const giorniControlli = this.getGiorniMese(this.state.cadenza.mese);

    const columns = [
      {
        Header: "ID",
        id: "id",
        accessor: (d) => d.id,
        show: false,
      },
      {
        Header: "Orario",
        id: "orario",
        accessor: (d) => d.orario,
        minWidth: 104,
      },
      {
        Header: "Giorno Mese",
        id: "giornoMese",
        accessor: (d) => d.giornoMese,
        minWidth: 104,
      },
      {
        Header: "Mese",
        id: "mese",
        accessor: (d) => d.mese,
        minWidth: 104,
        Cell: (props) => {
          if (props.value !== null) {
            switch (props.value) {
              case "JANUARY":
                return "GENNAIO";
              case "FEBRUARY":
                return "FEBBRAIO";
              case "MARCH":
                return "MARZO";
              case "APRIL":
                return "APRILE";
              case "MAY":
                return "MAGGIO";
              case "JUNE":
                return "GIUGNO";
              case "JULY":
                return "LUGLIO";
              case "AUGUST":
                return "AGOSTO";
              case "SEPTEMBER":
                return "SETTEMBRE";
              case "OCTOBER":
                return "OTTOBRE";
              case "NOVEMBER":
                return "NOVEMBRE";
              case "DECEMBER":
                return "DICEMBRE";
              default:
                return "-";
            }
          }
          return "-";
        },
      },
      {
        id: "eliminaBtn",
        Header: "Elimina",
        accessor: (row) => row,
        width: 66,
        Cell: (props) => (
          <IconButton
            size="small"
            disabled={false}
            onClick={() => {
              this.props.onEliminaCadenzaButtonClicked(props.index);
            }}
            style={{
              color: this.props.theme.palette.primary.main,
            }}
          >
            <HighlightOff />
          </IconButton>
        ),
      },
    ];

    return (
      <Grid
        container
        justify="center"
        alignItems="center"
        style={styles.container}
      >
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography variant="body1" style={{ fontWeight: 500 }} gutterBottom>
            Giorno del mese e orari del controllo
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
          <Grid container justify="center" style={styles.gridcontainer_column}>
            <FormControl style={styles.formcontrol}>
              <InputLabel id="giornoNotifica-label">
                Mese del controllo
              </InputLabel>
              <Select
                value={this.state.cadenza.mese}
                name="mese"
                onChange={this.onSelect}
                MenuProps={MenuProps}
              >
                <MenuItem disabled value={""}>
                  <em>Seleziona un mese</em>
                </MenuItem>
                {mesi.map((mese) => (
                  <MenuItem key={mese.value} value={mese.value}>
                    {mese.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl style={styles.formcontrol}>
              <InputLabel id="giornoMese-label">Giorno del mese</InputLabel>
              <Select
                value={this.state.cadenza.giornoMese}
                name="giornoMese"
                onChange={this.onSelect}
                MenuProps={MenuProps}
              >
                <MenuItem disabled value={0}>
                  <em>Seleziona il giorno</em>
                </MenuItem>
                {giorniControlli.map((giornomese) => (
                  <MenuItem key={giornomese} value={giornomese}>
                    {giornomese}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl style={styles.formcontrol}>
              <InputLabel id="orario-label">Ora del controllo</InputLabel>
              <Select
                value={this.state.cadenza.orario}
                name="orario"
                onChange={this.onSelect}
                MenuProps={MenuProps}
              >
                <MenuItem disabled value={""}>
                  <em>Seleziona un orario</em>
                </MenuItem>
                {orariControlli.map((orario) => (
                  <MenuItem key={orario.value} value={orario.value}>
                    {orario.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl style={styles.formcontrol}>
              <Button
                size="small"
                onClick={() => this.props.onAddCadenza(this.state.cadenza)}
                variant="contained"
                disabled={false}
                style={{
                  color: this.props.theme.palette.text.main,
                  margin: "10px",
                  backgroundColor: this.props.theme.palette.primary.main,
                }}
              >
                Aggiungi
              </Button>
            </FormControl>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          style={styles.tablecontainer}
        >
          <ReactTable
            filterable={false}
            resizable={true}
            showPageSizeOptions={true}
            showPageJump={true}
            defaultPageSize={5}
            //pages={this.state.pages}
            data={this.props.cadenze}
            columns={columns}
            //manual // informs React Table that you'll be handling sorting and pagination server-side
            //onFetchData={ (state, instance) => { this.fetchData(state.page, state.pageSize) } }
            previousText="Precedente"
            nextText="Successivo"
            noDataText="Nessun record"
            pageText="Pagina"
            ofText="di"
            rowsText="righe"
            pageJumpText="Vai a pagina"
            rowsSelectorText="righe per pagina"
          />
        </Grid>
      </Grid>
    );
  }
}

FormAnnuale.propTypes = {};
